/**
 * Tiempo que un código debe dejar de verse para considerar que el producto
 * salió del encuadre y que una nueva lectura es intencional.
 */
export const REARME_LECTURA_MS = 1200;

export interface EstadoLecturaCodigo {
  ultimoCodigo: string;
  ultimoVistoTs: number;
}

/**
 * Determina si una lectura debe emitirse al POS.
 *
 * Mientras el mismo código permanece en el encuadre no se vuelve a emitir, así
 * la cámara no agrega unidades por error. Si el código cambia, o si el producto
 * dejó de verse durante `REARME_LECTURA_MS` y vuelve a aparecer, se considera
 * una lectura nueva (y el POS pedirá confirmación si el producto ya está en el carrito).
 */
export function esLecturaNueva(
  codigo: string,
  estado: EstadoLecturaCodigo,
  ahora: number,
): boolean {
  return codigo !== estado.ultimoCodigo || ahora - estado.ultimoVistoTs >= REARME_LECTURA_MS;
}
